import { render, staticRenderFns } from "./Selects.vue?vue&type=template&id=4a1c205b&scoped=true"
import script from "./Selects.vue?vue&type=script&lang=js"
export * from "./Selects.vue?vue&type=script&lang=js"
import style0 from "./Selects.vue?vue&type=style&index=0&id=4a1c205b&prod&lang=scss&scoped=true"
import style1 from "./Selects.vue?vue&type=style&index=1&id=4a1c205b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1c205b",
  null
  
)

export default component.exports